<template>
  <div class="h-toolbarBg">
    <ejs-toolbar ref="toolBarForTask">
      <e-items>
        <e-item prefixIcon='icon hero-icon hero-icon-search' :tooltipText='$t("Pm.gnbPmDataQuery")' :click='buttonClick' operate='query'></e-item>
      </e-items>
    </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: 'ToolBarForGnbPmDataQueryRightList',
  data() {
    return {
    };
  },
  methods: {
    buttonClick(args){
      this.$parent.methodList(args.item.operate);
    }
  },
  watch: {
  }
};
</script>

<style>

</style>
